import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { HiOutlineDocumentDownload } from "react-icons/hi";
import Done from "./PaymentRequest/Done";
import Pending from "./PaymentRequest/Pending";
import All from "./PaymentRequest/All";
import CustomTabs from "../Common/CustomTabs";
import { useQuery } from "@apollo/client";
import { GET_ALL_REQUEST } from "../../Utils/Queries";
import Loader from "../Common/Loader";
import jsPDF from "jspdf";
import "jspdf-autotable";

const PaymentRequest = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);

  const { data, loading, error } = useQuery(GET_ALL_REQUEST);

  const [searchParams, setSearchParams] = useState("");


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(data?.fetchAllPendingWithdrawals?.items);
  }, [data]);

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    // Filter items based on the search term
    const filteredItems = data?.fetchAllPendingWithdrawals?.items?.filter(
      (item) => item?.user?.firstName.toLowerCase().includes(searchTerm)
    );

    setFilteredData(filteredItems);
    setSearchParams(searchTerm);
  };

  const pending_data = filteredData?.filter(
    (item) => item?.status === "PENDING"
  );
  const done_data = filteredData?.filter((item) => item?.status === "PAID");

  const TabData = [
    {
      label: "All",
      component: <All data={filteredData} />,
    },
    {
      label: "Pending",
      component: <Pending data={pending_data} />,
    },
    {
      label: "Done",
      component: <Done data={done_data} />,
    },
  ];

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);

    // Add heading
    doc.text(`Mamaket Payment Request - ${formatDate(new Date())}`, 10, 10);
    // Set custom font and size for the table
    doc.setFont("helvetica");
    doc.setFontSize(12);

    const tableColumn = [
      "Request ID",
      "User",
      "Amount",
      "Account",
      "BankName",
      "Routing No.",
      "Status",
      "Date",
    ];
    const tableRows = [];

    filteredData.forEach((item) => {
      const itemData = [
        item._id,
        `${item.user.firstName} ${item.user.lastName}`,
        `${item.amount}`,
        item.bank.accountNumber,
        item.bank.bankName,
        item.bank.routingNumber,
        item.status,
        formatDate(item?.createdAt),
      ];
      tableRows.push(itemData);
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 15,
      styles: {
        fontSize: 6,
        font: "helvetica",
      },
      headStyles: {
        fillColor: [92, 48, 105],
      },
    });

    doc.save(`mamaket_PR(${new Date()}).pdf`);
  };
  return (
    <>
      {loading && <Loader />}
      <Box sx={{ bgcolor: "#fff", p: 2 }}>
        <Box
          onClick={() => navigate("/dashboard/mamapurse")}
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: 2,
            cursor: "pointer",
            width: "fit-content",
          }}
        >
          <IoIosArrowRoundBack /> <Typography>Payment Requests</Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TextField
            sx={{ width: "50%" }}
            size="small"
            value={searchParams}
            onChange={handleSearch}
            placeholder="Search by ID, Names..."
            InputProps={{
              style: {
                background: "#F7F6F6",
              },
              startAdornment: (
                <InputAdornment position="start">
                  <FiSearch />
                </InputAdornment>
              ),
            }}
          />
          {/* <TextField
            sx={{ width: "23%" }}
            size="small"
            InputProps={{
              style: {
                background: "#F7F6F6",
              },
            }}
            select
          ></TextField> */}
          <Button
          onClick={generatePDF}
            sx={{ bgcolor: "#f7f6f6", px: 4 }}
            endIcon={<HiOutlineDocumentDownload />}
          >
            Download
          </Button>
        </Box>
        <Box sx={{ mt: 4 }}>
          <CustomTabs
            variant="standard"
            value={value}
            handleChange={handleChange}
            data={TabData}
          />
        </Box>
      </Box>
    </>
  );
};

export default PaymentRequest;

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getUTCFullYear();

  return `${day} ${month} ${year}`;
};
